import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=57097053&scoped=true&"
import script from "./ChatConversation.vue?vue&type=script&lang=js&"
export * from "./ChatConversation.vue?vue&type=script&lang=js&"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=57097053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57097053",
  null
  
)

export default component.exports